"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLoadingMaskContent = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LoadingMaskMixin = require("../../mixins/components/LoadingMaskMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledLoadingMaskContent = /*#__PURE__*/_styledComponents.default.div.withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['loading'])
}).withConfig({
  displayName: "StyledLoadingMaskContent",
  componentId: "c11n-8-107-0__sc-1brcmz6-0"
})(["", ""], _LoadingMaskMixin.LoadingMaskContentMixin);
exports.StyledLoadingMaskContent = StyledLoadingMaskContent;